import { Heart, Search, UsersRound, HandHeart, PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

const steps = [
  { icon: Search, number: "1", title: "Znajdź schronisko", desc: "Szukaj po lokalizacji lub nazwie", highlight: false },
  { icon: Heart, number: "2", title: "Sprawdź potrzeby", desc: "Zobacz, czego aktualnie potrzebują", highlight: false },
  { icon: HandHeart, number: "3", title: "Pomóż!", desc: "Przywieź dary lub skontaktuj się", highlight: false },
  { icon: UsersRound, number: "4", title: "Podziel się info", desc: "Dodaj brakujące info lub udostępnij 💚", highlight: true, iconColor: "#8B5CF6", iconBg: "#F3E8FF" },
];

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramPost3 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;
  
  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Main content - centered */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "100px 100px",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        <h1
          style={{
            fontSize: "56px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0",
            textAlign: "center",
            lineHeight: 1.2,
          }}
        >
          Chcesz pomóc?<br />To proste!
        </h1>

        {/* Steps - 2x2 grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "16px",
            width: "100%",
            maxWidth: "820px",
          }}
        >
          {steps.map((s) => (
            <div
              key={s.number}
              style={{
                background: "rgba(255,255,255,0.95)",
                borderRadius: "20px",
                padding: "20px 24px",
                display: "flex",
                alignItems: "center",
                gap: "16px",
                boxShadow: s.highlight 
                  ? "0 6px 24px rgba(139,92,246,0.25)" 
                  : "0 4px 20px rgba(0,0,0,0.06)",
                border: s.highlight ? "3px solid #8B5CF6" : "none",
              }}
            >
              {/* Number circle */}
              <div
                style={{
                  width: "44px",
                  height: "44px",
                  background: "linear-gradient(135deg, #5D9A7D 0%, #4E8A6E 100%)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <span style={{ fontSize: "22px", fontWeight: 800, color: "#FFFFFF" }}>
                  {s.number}
                </span>
              </div>
              
              {/* Icon */}
              <div
                style={{
                  width: "44px",
                  height: "44px",
                  background: s.iconBg 
                    ? s.iconBg 
                    : "linear-gradient(135deg, #E8F5EA 0%, #D4EED8 100%)",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <s.icon style={{ width: "22px", height: "22px", color: s.iconColor || "#4E8A6E" }} />
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "20px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>
                  {s.title}
                </h3>
                <p style={{ fontSize: "15px", color: "#6B8A7A", margin: "2px 0 0", fontWeight: 500 }}>
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Logo with brand name - fixed position */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "56px",
              height: "56px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <PawPrint style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "36px", fontWeight: 800, color: "#2D5A3D" }}>
            GdzieSchronisko
          </span>
        </div>
      </div>
    </GraphicBackground>
  );
};

